export default __webpack_public_path__ + "static/media/about-us-03.51ad2c10.jpg";